import { c as _c } from "react/compiler-runtime";
import type { ApiUpdateWaveRequest } from "@/generated/models/ApiUpdateWaveRequest";
import type { ApiWave } from "@/generated/models/ApiWave";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import type { WaveGroupType } from "../WaveGroup.types";
import { buildWaveUpdateBody } from "./buttons/utils/waveGroupEdit";
import WaveGroupRemoveModal from "./WaveGroupRemoveModal";
export default function WaveGroupRemove(t0) {
  const $ = _c(12);
  const {
    wave,
    type,
    isEditOpen,
    setIsEditOpen,
    onWaveUpdate
  } = t0;
  let t1;
  if ($[0] !== type || $[1] !== wave) {
    t1 = () => buildWaveUpdateBody(wave, type, null);
    $[0] = type;
    $[1] = wave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getBody = t1;
  let t2;
  if ($[3] !== getBody || $[4] !== onWaveUpdate) {
    t2 = async () => {
      const body = getBody();
      await onWaveUpdate(body);
    };
    $[3] = getBody;
    $[4] = onWaveUpdate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onRemove = t2;
  let t3;
  if ($[6] !== isEditOpen || $[7] !== onRemove || $[8] !== setIsEditOpen) {
    t3 = isEditOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><WaveGroupRemoveModal closeModal={() => setIsEditOpen(false)} removeGroup={onRemove} /></CommonAnimationOpacity>;
    $[6] = isEditOpen;
    $[7] = onRemove;
    $[8] = setIsEditOpen;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <CommonAnimationWrapper mode="sync" initial={true}>{t3}</CommonAnimationWrapper>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp(e) {
  return e.stopPropagation();
}